"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.freshen = void 0;
function freshen(usedNames, name) {
    usedNames = new Set(usedNames);
    let counter = 1;
    let freshName = name;
    while (true) {
        if (usedNames.has(freshName)) {
            freshName = `${name}${counter}`;
            counter++;
        }
        else {
            return freshName;
        }
    }
}
exports.freshen = freshen;
//# sourceMappingURL=freshen.js.map